import styled from '@emotion/styled';
import { SPACING } from '@zola/zola-ui/src/styles/emotion';

export const Wrapper = styled.div`
  padding: 0 ${SPACING.S24};
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;

  h2 {
    text-align: center;
  }

  p {
    margin-top: ${SPACING.S16};
  }

  a {
    margin-top: ${SPACING.S32};
  }
`;
